/** @flow */

import type { State } from "@store/reducers";
import type {
  HierarchyChangelog,
  HierarchyChangelogState,
} from "@modules/hierarchy/reducer/change-log/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType, AuthoredBy } from "@types";

export const getHierarchyChangelogState = (state: State): HierarchyChangelogState =>
  state.hierarchy.changelog;

export const getHierarchyChangelog = (state: State): Array<HierarchyChangelog> =>
  state.hierarchy.changelog.list.content;

export const getHierarchyChangelogPagination = (state: State): PaginationExtendedType =>
  getPagination(state.hierarchy.changelog.list);

export const getHierarchyChangelogPage = (state: State): number =>
  (getHierarchyChangelogPagination(state) || {}).pageNumber || 0;

export const getHierarchyChangelogFilters = (state: State): Object =>
  state.form["hierarchy-change-log-filter"].values;

export const getHierarchyChangelogUsers = (state: State): Array<AuthoredBy> =>
  state.hierarchy.changelog.users;
